export enum TagType {
    PRIVATE=1,
    PUBLIC
}
